import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { SearchGeneralManagerModel } from 'src/app/admin-panel/models/system-profiles/search-general-manager.model';
import { UserProfileModel } from 'src/app/admin-panel/models/system-profiles/user-profile.model';
import { AdministratorService } from 'src/app/admin-panel/services/system-profiles/administrator-service';
import { AddOrEditGeneralManagerComponent } from './add-or-edit-general-manager/add-or-edit-general-manager.component';
import { DeleteGeneralManagerComponent } from './delete-general-manager/delete-general-manager.component';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-general-manager',
  templateUrl: './general-manager.component.html',
  styleUrls: ['./general-manager.component.scss']
})
export class GeneralManagerComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public searchAGeneralManagerModel: SearchGeneralManagerModel = new SearchGeneralManagerModel();
  public userProfileList: Array<UserProfileModel>;
  public totalPages: number;
  public totalRecords: number;
  public imagePath: string = './assets/images/icons/profile-picture-placeholder.png'
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public administratorService: AdministratorService,
    public translate: TranslateService,
    private messageService: MessageService
  ) {


    this.userProfileList = new Array<UserProfileModel>();

  }

  ngOnInit(): void {
    this.getAllGeneralManagers(this.searchAGeneralManagerModel)
  }
  //#endregion

  //#region Public Methods

  getAllGeneralManagers(searchModel: SearchGeneralManagerModel) {
    this.administratorService.getAllAdmins(searchModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.totalPages = response.totalPages;
          this.totalRecords = response.totalRecords;
          if (this.searchAGeneralManagerModel.pageNumber > 1) {
            this.userProfileList = this.userProfileList.concat(response.data)
          }
          else {
            this.userProfileList = response.data;
          }
        },
        error: errorResponse => {
        }
      });

  };
  searhGeneralManagers(searchModel: SearchGeneralManagerModel) {
    searchModel.pageNumber = 1;
    this.getAllGeneralManagers(searchModel)
  }
  clearSearch() {
    this.searchAGeneralManagerModel = new SearchGeneralManagerModel();
    this.getAllGeneralManagers(this.searchAGeneralManagerModel);
  }
  loadMoreUser() {
    this.searchAGeneralManagerModel.pageNumber = this.searchAGeneralManagerModel.pageNumber + 1;
    this.getAllGeneralManagers(this.searchAGeneralManagerModel);
  }
  addNewGeneralManager() {
    const ref = this.dialogService.open(AddOrEditGeneralManagerComponent, {
      header: this.translate.instant('SYSTEM_PROFILES.ADD_ADMINISTRATOR'),
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAGeneralManagerModel.pageNumber = 1;
        this.getAllGeneralManagers(this.searchAGeneralManagerModel);
        let summary = this.translate.instant('SYSTEM_PROFILES.USER_ADDED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  editGeneralManager(userId: string) {
    const ref = this.dialogService.open(AddOrEditGeneralManagerComponent, {
      data: {
        id: userId
      },
      header: this.translate.instant('SYSTEM_PROFILES.EDIT_ADMINISTRATOR'),
      width: '760px',
      styleClass: 'ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAGeneralManagerModel.pageNumber = 1;
        this.getAllGeneralManagers(this.searchAGeneralManagerModel);
        let summary = this.translate.instant('SYSTEM_PROFILES.USER_UPDATED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  deleteGeneralManager(userId: string) {
    const ref = this.dialogService.open(DeleteGeneralManagerComponent, {
      data: {
        id: userId
      },
      header: this.translate.instant('SYSTEM_PROFILES.DELETE_ADMINISTRATOR'),
      width: '450px',
      styleClass: 'ml_200 , mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        this.searchAGeneralManagerModel.pageNumber = 1;
        this.getAllGeneralManagers(this.searchAGeneralManagerModel);
        let summary = this.translate.instant('SYSTEM_PROFILES.USER_DELETED');
        this.messageService.add({severity:'success', summary, life:3000});
      }
    });
  }
  //#endregion
  //#Private Methods
  //#endregion
}
